module.exports = __webpack_public_path__ + "static/media/feature-tasks.a9348533.png";